import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';
import moment from 'moment';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  contratosInRequest,
  deleteContrato,
  findContrato,
  recordFiltering,
} from '~/store/modules/contrato/actions';

import MyTabs from './Tabs';

function ContratoList() {
  const redux = useSelector((state) => state.contrato);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idcontrato',
        label: t('s.cadastro.contrato.idcontrato'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nomecontrato',
        label: t('s.cadastro.contrato.nomecontrato'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'datainicialcontrato',
        label: t('s.cadastro.contrato.datainicialcontrato'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      {
        id: 'datafinalcontrato',
        label: t('s.cadastro.contrato.datafinalcontrato'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
      },
      {
        id: 'statuscontrato',
        label: t('s.cadastro.contrato.statuscontrato'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  // imprime em pdf ou xls

  const fieldlist = [
    'idcontrato',
    'nomecontrato',
    'datainicialcontrato',
    'datafinalcontrato',
    'statuscontrato',
  ];

  const substituirHeader = {
    idcontrato: t('s.cadastro.contrato.idcontrato'),
    nomecontrato: t('s.cadastro.contrato.nomecontrato'),
    datainicialcontrato: t('s.cadastro.contrato.datainicialcontrato'),
    datafinalcontrato: t('s.cadastro.contrato.datafinalcontrato'),
    statuscontrato: t('s.cadastro.contrato.statuscontrato'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findContrato}
      remove={deleteContrato}
      form={MyTabs}
      keys="idcontrato"
      detach="idcontrato"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'contratos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Centros de Custo',
          substituirValores: {
            statuscontrato: {
              L: t('s.geral.opcoes.liberado'),
              B: t('s.geral.opcoes.bloqueado'),
              C: t('s.geral.opcoes.cancelado'),
            },
          },
        })
      }
    />
  );
}

export default ContratoList;
